import { render, staticRenderFns } from "./ActiveDomainsList.vue?vue&type=template&id=531dfbe8"
import script from "./ActiveDomainsList.vue?vue&type=script&lang=js"
export * from "./ActiveDomainsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports